var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M12 14.7V21M8.531 7.777v1.918c0 .187 0 .28-.017.37a1 1 0 0 1-.077.229 2 2 0 0 1-.21.3l-1.36 1.766C6.288 13.11 6 13.484 6 13.8c0 .274.12.533.326.704.237.197.7.197 1.624.197h8.1c.924 0 1.386 0 1.624-.197A.91.91 0 0 0 18 13.8c0-.315-.289-.69-.866-1.439l-1.361-1.766c-.113-.146-.17-.219-.21-.3a1 1 0 0 1-.077-.229c-.018-.09-.018-.183-.018-.37V7.777c0-.103 0-.155.006-.206a1 1 0 0 1 .025-.135c.013-.05.032-.097.069-.193l.874-2.268c.255-.662.382-.993.329-1.258a.9.9 0 0 0-.37-.567C16.183 3 15.841 3 15.153 3H8.846c-.686 0-1.03 0-1.247.15a.9.9 0 0 0-.37.567c-.053.265.074.596.33 1.258l.873 2.268c.037.096.056.144.069.193a1 1 0 0 1 .025.135c.005.05.005.103.005.206"
  })));
};
export default SvgPin;